import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    data: Object
  };

  connect() {
    if (this.hasDataValue && Object.keys(this.dataValue).length > 0) {
      this.buildChart();
    }
  }

  buildChart() {
    const data = this.dataValue;
    const score = parseFloat(data.score).toFixed(1) || 0;
    const percentage = (parseFloat(data.percentage) / 10) || 0;

    Highcharts.chart(this.element, {
      chart: {
        type: 'solidgauge',
        height: '200px',
        backgroundColor: 'transparent'
      },

      title: {
        text: null
      },

      credits: {
        enabled: false
      },

      tooltip: {
        enabled: false
      },

      pane: {
        center: ['50%', '60%'],
        size: '120%',
        startAngle: -90,
        endAngle: 90,
        background: {
          backgroundColor: '#e5e5e7',
          innerRadius: '80%',
          outerRadius: '100%',
          shape: 'arc',
          borderWidth: 0
        }
      },

      yAxis: {
        stops: [
          [0.1, '#f5140a'],
          [0.5, '#ffc733'],
          [1.0, '#57db61']
        ],
        lineWidth: 0,
        tickWidth: 0,
        minorTickInterval: null,
        tickAmount: 1,
        min: 1,
        max: 10,
        labels: {
          enabled: false,
          y: 20,
          distance: '90%'
        }
      },

      plotOptions: {
        solidgauge: {
          dataLabels: {
            y: 5,
            borderWidth: 0,
            useHTML: true
          },
          borderRadius: 5,
          stickyTracking: false,
          rounded: true
        }
      },

      series: [{
        name: 'Score',
        data: [{
          y: percentage,
          dataLabels: {
            format: `
              <div style="text-align: center; padding-bottom: 3.5rem">
                <span style="font-size: 3rem; font-weight: 600; color: #242424">${score}</span>
                <br>
                <span style="font-weight: 400; font-size: 12px; color: #242424">out of 10</span>
              </div>
            `
          }
        }],
        radius: '100%',
        innerRadius: '80%'
      }]
    });
  }
}
